
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { SubsidiariesStoreReducer } from './reducer';
import { SubsidiariesStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, SubsidiariesStoreReducer),
		EffectsModule.forFeature([SubsidiariesStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SubsidiariesStoreModule { }
